<template>
  <nav class="py-5 px-7 w-full bg-[#f0f2f5] shadow-md">
    <h1 class="font-semibold text-black text-2xl" v-if="title">{{ title }}</h1>
  </nav>
</template>



<script lang="ts">
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};
</script>
